exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,400italic,500,500italic,700,700italic,300);", ""]);

// module
exports.push([module.id, "/*=== Load in the Roboto fonts ===*/\n\n/* Roboto */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/imittal/Projects/angular_projects/my-adept/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/imittal/Projects/angular_projects/my-adept/node_modules/postcss-loader/lib?{"ident":"postcss"}!/Users/imittal/Projects/angular_projects/my-adept/src/app/css/gt_fonts.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss"}!../../../../../src/app/css/gt_fonts.css
// module chunks = styles